import React from 'react';

type SVGNoMoreShowingsProps = React.SVGProps<SVGSVGElement>;

const SVGNoMoreShowings = (props: SVGNoMoreShowingsProps) => (
    <svg
      width="111"
      height="107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M93.308 25.563h-.581V9.615a9.23 9.23 0 0 0-9.23-9.23h-33.79a9.23 9.23 0 0 0-9.23 9.23v87.492a9.23 9.23 0 0 0 9.23 9.23h33.789a9.23 9.23 0 0 0 9.23-9.23V36.915h.582V25.563Z"
          fill="#3F3D56"
        />
        <path
          d="M90.833 8.997v88.728a7.001 7.001 0 0 1-6.998 7H49.353a7.002 7.002 0 0 1-7.003-7V8.997a7.002 7.002 0 0 1 7.002-7h4.183a3.329 3.329 0 0 0 3.08 4.583h19.659a3.33 3.33 0 0 0 3.079-4.582h4.48a7 7 0 0 1 7 6.998v.001Z"
          fill="#fff"
        />
        <path
          d="M66.585 44.616c7.95 0 14.396-6.445 14.396-14.396 0-7.95-6.445-14.396-14.396-14.396-7.95 0-14.395 6.446-14.395 14.396 0 7.95 6.445 14.396 14.395 14.396Z"
          fill="#1665FC"
        />
        <path
          d="M82.286 60.106H51.644a.568.568 0 0 1-.567-.568v-7.6a.568.568 0 0 1 .568-.568h30.64a.569.569 0 0 1 .568.568v7.6a.568.568 0 0 1-.567.568Zm-30.642-8.509a.34.34 0 0 0-.34.34v7.601a.34.34 0 0 0 .34.34h30.642a.34.34 0 0 0 .34-.34v-7.6a.341.341 0 0 0-.34-.341H51.644Z"
          fill="#E6E6E6"
        />
        <path
          d="M61.12 54.107a.397.397 0 0 0 0 .795h18.726a.398.398 0 1 0 .013-.794H61.12ZM61.12 56.49a.397.397 0 0 0 0 .795h18.726a.397.397 0 0 0 .03-.794H61.12ZM82.286 72.774H51.644a.568.568 0 0 1-.567-.567v-7.601a.568.568 0 0 1 .568-.567h30.64a.568.568 0 0 1 .568.567v7.6a.568.568 0 0 1-.567.568Zm-30.642-8.508a.34.34 0 0 0-.34.34v7.6a.34.34 0 0 0 .34.341h30.642a.341.341 0 0 0 .34-.34v-7.601a.341.341 0 0 0-.34-.34H51.644Z"
          fill="#E6E6E6"
        />
        <path
          d="M61.12 66.817a.398.398 0 0 0 0 .794h18.726a.397.397 0 0 0 .013-.794H61.12ZM61.12 69.2a.397.397 0 1 0 0 .795h18.726a.398.398 0 0 0 .013-.794H61.12ZM82.286 85.484H51.644a.568.568 0 0 1-.567-.567v-7.6a.568.568 0 0 1 .568-.568h30.64a.569.569 0 0 1 .568.567v7.601a.568.568 0 0 1-.567.568Zm-30.642-8.508a.34.34 0 0 0-.34.34v7.601a.34.34 0 0 0 .34.34h30.642a.34.34 0 0 0 .34-.34v-7.6a.341.341 0 0 0-.34-.341H51.644Z"
          fill="#E6E6E6"
        />
        <path
          d="M61.12 79.528a.397.397 0 0 0 0 .794h18.726a.398.398 0 1 0 .013-.794H61.12ZM61.12 81.911a.397.397 0 0 0 0 .795h18.726a.398.398 0 1 0 .013-.795H61.12ZM110.551 106.615H.45c-.16 0-.29-.07-.29-.156s.13-.156.29-.156H110.55c.159 0 .289.07.289.156s-.129.156-.289.156ZM105.888 100.538a2.91 2.91 0 0 1-2.804-.494c-.982-.824-1.289-2.182-1.54-3.44l-.741-3.718 1.551 1.068c1.116.768 2.257 1.56 3.029 2.673.773 1.113 1.11 2.632.489 3.836"
          fill="#E6E6E6"
        />
        <path
          d="M105.648 105.299c.196-1.423.397-2.863.259-4.301-.121-1.277-.511-2.524-1.304-3.546a5.905 5.905 0 0 0-1.513-1.372c-.152-.095-.291.145-.14.24a5.608 5.608 0 0 1 2.218 2.677c.483 1.228.561 2.567.477 3.872-.05.789-.157 1.573-.264 2.356a.142.142 0 0 0 .097.171.138.138 0 0 0 .105-.014.138.138 0 0 0 .065-.083Z"
          fill="#F2F2F2"
        />
        <path
          d="M104.243 103.016a2.13 2.13 0 0 1-1.862.961c-.943-.044-1.729-.702-2.436-1.326l-2.092-1.848 1.384-.066c.996-.048 2.018-.092 2.967.215.949.307 1.823 1.046 1.997 2.027"
          fill="#E6E6E6"
        />
        <path
          d="M106.2 106.116c-.939-1.663-2.03-3.511-3.978-4.102a4.446 4.446 0 0 0-1.673-.173c-.178.015-.134.29.044.274a4.126 4.126 0 0 1 2.671.707c.753.512 1.339 1.225 1.835 1.98.304.462.576.946.848 1.427.087.154.341.043.253-.113Z"
          fill="#F2F2F2"
        />
        <path
          d="M55.467 58.074a2.383 2.383 0 1 0 0-4.766 2.383 2.383 0 0 0 0 4.766Z"
          fill="#1665FC"
        />
        <path
          d="M54.327 55.246c-.028 0-.05.177-.05.397 0 .22.022.397.05.397h2.343c.027.004.05-.171.05-.39a.886.886 0 0 0-.048-.404h-2.345Z"
          fill="#E6E6E6"
        />
        <path
          d="M55.467 70.79a2.383 2.383 0 1 0 0-4.767 2.383 2.383 0 0 0 0 4.767Z"
          fill="#1665FC"
        />
        <path
          d="M54.327 67.961c-.028 0-.05.178-.05.398 0 .219.022.397.05.397h2.343c.027.003.05-.171.05-.39a.886.886 0 0 0-.048-.404h-2.345Z"
          fill="#E6E6E6"
        />
        <path
          d="M55.467 83.5a2.383 2.383 0 1 0 0-4.767 2.383 2.383 0 0 0 0 4.767Z"
          fill="#1665FC"
        />
        <path
          d="M54.327 80.671c-.028 0-.05.178-.05.397 0 .22.022.398.05.398h2.343c.027.003.05-.171.05-.39a.886.886 0 0 0-.048-.404h-2.345Z"
          fill="#E6E6E6"
        />
        <path
          d="m63.476 26.267-.844.843 7.063 7.063.844-.843-7.063-7.063Z"
          fill="#fff"
        />
        <path
          d="m70.538 27.11-.843-.843-7.063 7.063.843.843 7.063-7.063Z"
          fill="#fff"
        />
        <path
          d="M13.617 68.385a1.499 1.499 0 0 0 .803-2.154l3.513-4.004-2.743-.379-2.915 3.861a1.507 1.507 0 0 0 1.341 2.676ZM17.853 103.878h-2.45l-1.166-9.45h3.617v9.45Z"
          fill="#B8A28E"
        />
        <path
          d="M18.478 106.253h-7.9v-.1a3.077 3.077 0 0 1 3.075-3.075h4.825v3.175Z"
          fill="#2F2E41"
        />
        <path
          d="m30.679 101.827-2.34.727-3.916-8.68 3.454-1.072 2.802 9.025Z"
          fill="#B8A28E"
        />
        <path
          d="m31.98 103.911-7.545 2.342-.03-.095a3.076 3.076 0 0 1 2.025-3.849l4.609-1.431.941 3.033Z"
          fill="#2F2E41"
        />
        <path
          d="m15.977 60.306-3.629 4.156 2.841.256.788-4.412Z"
          fill="#E6E6E6"
        />
        <path
          d="M14.56 65.663s-1.261.63-1.419 3.466c-.158 2.836.473 10.242.473 10.242s-.63 3.309 0 6.302c.63 2.994-.63 13.865.157 13.865.788 0 4.884.472 5.042 0 .158-.473.315-7.563.315-7.563s1.26-3.624 0-5.83c0 0 4.401 7.686 7.248 13.55.623 1.284 5.357-.157 4.569-1.575-.788-1.418-2.678-7.878-2.678-7.878s-1.419-4.727-3.94-6.775l1.261-10.083s2.679-6.775 1.103-7.72c-1.575-.946-12.132-.001-12.132-.001Z"
          fill="#1665FC"
        />
        <path
          d="M19.285 39.981a4.096 4.096 0 1 0 0-8.192 4.096 4.096 0 0 0 0 8.192Z"
          fill="#B8A28E"
        />
        <path
          d="m23.855 40.296-5.093 2.994s-1.95 1.098-2.678 2.993c-.777 2.02-.325 4.865 0 5.515.63 1.26-.265 4.411-.265 4.411l-.787 7.248s-2.836 2.678-.63 2.993c2.205.316 6.144-.157 8.508 0 2.363.158 5.041.473 4.253-1.103-.787-1.576-1.733-2.678-.787-5.829.74-2.465.707-11.685.659-15.579a3.135 3.135 0 0 0-1.523-2.648l-1.657-.995Z"
          fill="#E8F0FF"
        />
        <path
          opacity=".1"
          d="m21.57 45.26.474 9.61-4.581 9.277-.777-.296 4.727-8.665.158-9.926ZM26.77 56.919v-1.104l-5.357 8.824 5.356-7.72Z"
          fill="#000"
        />
        <path
          d="m16.378 32.09-.676-.27s1.416-1.56 3.386-1.424l-.554-.61s1.354-.542 2.585.881c.648.748 1.397 1.628 1.864 2.618h.725l-.302.667 1.059.666-1.087-.119a3.688 3.688 0 0 1-.103 1.726l.03.527s-1.261-1.951-1.261-2.222v.678s-.678-.61-.678-1.017l-.37.475-.184-.745-2.278.745.37-.61-1.417.203.554-.745s-1.6.88-1.662 1.626c-.062.746-.862 1.695-.862 1.695l-.37-.678s-.553-3.05 1.231-4.067Z"
          fill="#2F2E41"
        />
        <path
          d="M19.028 68.83a1.498 1.498 0 0 0 .409-2.261l2.746-4.565-2.766.114-2.184 4.318a1.508 1.508 0 0 0 1.795 2.395Z"
          fill="#B8A28E"
        />
        <path
          d="m25.273 42.345 1.181-.236s3.546 2.6 2.443 7.799c-1.103 5.2-5.987 13.077-5.987 13.077s-1.104 1.418-1.419 1.733c-.314.315-.945 0-.63.473.316.472-.472.787-.472.787s-3.467 0-3.151-1.26c.315-1.26 5.672-10.242 5.672-10.242l-.788-8.35s-.63-4.096 3.15-3.78Z"
          fill="#E8F0FF"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(.16 .385)"
            d="M0 0h110.679v106.23H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default SVGNoMoreShowings;
